import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles(theme => ({
    totalComments: {
        background: '#A8A8A83D',
        width: 28,
        height: 28,
        borderRadius: '50%',
        fontSize: 11,
        display: 'block',
        textAlign: 'center',
        padding: 6,
        marginLeft: 5,
    }
}));
